export default __webpack_public_path__ + "static/media/Fiseti.e87f8d73.svg";